import { useState } from 'react';

import { FaPlus } from "react-icons/fa";
import ViewAdvertiseService from '../components/ViewAdvertiseService.jsx';
import EditService from '../components/EditService.jsx';

import classes from './AdvertiseServices.module.css';

import { initEditState, EDIT_OPEN } from '../util/advertiseEditState.jsx';

function AdvertiseServices({ services, min_order, max_order }) {

  const new_order = max_order + 1000;

  const [editState, setEditState] = useState(initEditState());

  const [addServiceForm, setAddServiceForm] = useState(false);

  const nullService = {};

  console.log(`AdvertiseServices : min_order: ${JSON.stringify(min_order)} max_order: ${JSON.stringify(max_order)} new_order: ${new_order}`);
  let service = null;
  for (let index = 0; index < services.length; index++) {
    service = services[index];
    console.log(`AdvertiseServices : id: ${service.id} title: ${service.title} do: ${service.display_order} po: ${service.prev_order} pi: ${service.prev_id} no: ${service.next_order} ni: ${service.next_id}`);
  }

  function srvInfoEditted() {
    let newState = initEditState();
    newState[EDIT_OPEN] = false;
    setEditState(newState);
  }

  function addService() {
    console.log(`Add Service`);
    setAddServiceForm(true);
    srvInfoEditted();
  }

  return (
    <div className={classes.services}>
      <table className={classes.service}>
      <tr>
      <th>
        <h2 style={{ textAlign: 'center' }}>List of Services</h2>
      </th>
      <th>
        <button disabled={!editState[EDIT_OPEN]} onClick={addService}>
        <FaPlus />Add Service
        </button>
      </th>
      </tr>
      {addServiceForm &&
        <>
        <tr>
        <td colspan={2}>
          <EditService
            srv={nullService}
            editState={editState}
            setEditState={setEditState}
            setEditForm={setAddServiceForm}
            newOrder={new_order} />
        </td>
        </tr>
        </>
      }
      {services.map((service) => (
        <tr>
          <ViewAdvertiseService
            srv={service}
            editState={editState}
            setEditState={setEditState}
            srvInfoEditted={srvInfoEditted}
            minOrder={min_order}
            maxOrder={max_order}
          />
        </tr>
        ))}
      </table>
    </div>
  );
}

export default AdvertiseServices;
